import { useState } from "react";

interface Props {
  text: string;
  label: string;
  hint?: string;
  className?: string;
}

/** Copy `text` to the clipboard and flash "✓ copied" for 1.5s.
 *  Falls through with no feedback if the clipboard API rejects (older
 *  browsers, insecure context) — failure is silent on purpose since this
 *  is a convenience action, not a critical flow. */
export function CopyButton({ text, label, hint, className = "" }: Props) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // Ignore — modern browsers in HTTPS context all support this.
    }
  };
  return (
    <button
      type="button"
      onClick={onCopy}
      title={hint}
      className={
        className ||
        "text-xs px-2 py-1.5 min-h-[36px] inline-flex items-center gap-1 text-zinc-400 hover:text-accent-light transition-colors"
      }
    >
      {copied ? "✓ copied" : label}
    </button>
  );
}
